import { Box } from '@mui/material'
import { InventoryResult } from 'Features/Projects/Scenarios/Inventory/Inventory.types'
import { GridColDef } from '@mui/x-data-grid-premium'
import { BaseTable } from 'Features/Projects/Table/BaseTable.view'

export const InventoryResultsTable = ({
  data,
  isRefetching,
  handleRefetch,
}: {
  data: InventoryResult[]
  isRefetching: boolean
  handleRefetch: () => void
}) => {
  const COLUMN_WIDTH = 150

  const columns: GridColDef[] = [
    {
      field: 'baseSourceSiteKey',
      headerName: 'Base Source Site Key',
      width: COLUMN_WIDTH,
    },
    {
      field: 'baseSourceSiteCode',
      headerName: 'Base Source Site Code',
      width: COLUMN_WIDTH,
    },
    { field: 'siteKey', headerName: 'Site Key', width: COLUMN_WIDTH },
    { field: 'siteCode', headerName: 'Site Code', width: COLUMN_WIDTH },
    { field: 'skuGroupKey', headerName: 'SKU Group Key', width: COLUMN_WIDTH },
    {
      field: 'skuGroupCode',
      headerName: 'SKU Group Code',
      width: COLUMN_WIDTH,
    },
    { field: 'segment', headerName: 'Segment', width: COLUMN_WIDTH },
    {
      field: 'minimumOrderQuantity',
      headerName: 'Min Order Qty',
      width: COLUMN_WIDTH,
      type: 'number',
    },
    {
      field: 'stockPeriod',
      headerName: 'Stock Period',
      width: COLUMN_WIDTH,
      type: 'number',
    },
    {
      field: 'serviceLevel',
      headerName: 'Service Level',
      width: COLUMN_WIDTH,
      type: 'number',
    },
    {
      field: 'replenishmentCycleTime',
      headerName: 'Replenishment Cycle Time',
      width: COLUMN_WIDTH,
      type: 'number',
    },
    {
      field: 'replenishmentTypeCode',
      headerName: 'Replenishment Type Code',
      width: COLUMN_WIDTH,
    },
    {
      field: 'supplyTypeCode',
      headerName: 'Supply Type Code',
      width: COLUMN_WIDTH,
    },
    {
      field: 'actualBAUVolume',
      headerName: 'Actual BAU Volume',
      width: COLUMN_WIDTH,
      type: 'number',
    },
    {
      field: 'actualSafetyStockVolume',
      headerName: 'Actual Safety Stock Volume',
      width: COLUMN_WIDTH,
      type: 'number',
    },
    {
      field: 'actualCycleStockVolume',
      headerName: 'Actual Cycle Stock Volume',
      width: COLUMN_WIDTH,
      type: 'number',
    },
    {
      field: 'cycleStockVolume',
      headerName: 'Cycle Stock Volume',
      width: COLUMN_WIDTH,
      type: 'number',
    },
    {
      field: 'hybridSafetyStockVolume',
      headerName: 'Hybrid Safety Stock Volume',
      width: COLUMN_WIDTH,
      type: 'number',
    },
    {
      field: 'unusedInventory',
      headerName: 'Unused Inventory',
      width: COLUMN_WIDTH,
      type: 'number',
    },
    {
      field: 'actualInventoryValue',
      headerName: 'Actual Inventory Value',
      width: COLUMN_WIDTH,
      type: 'number',
    },
    {
      field: 'costPerUnit',
      headerName: 'Cost Per Unit',
      width: COLUMN_WIDTH,
      type: 'number',
    },
    {
      field: 'forecastAccuracyByForecastError',
      headerName: 'Forecast Accuracy (Error)',
      width: COLUMN_WIDTH,
      type: 'number',
    },
    {
      field: 'forecastAccuracyByDemandVariability',
      headerName: 'Forecast Accuracy (Variability)',
      width: COLUMN_WIDTH,
      type: 'number',
    },
    {
      field: 'ssVolumeByForecastError',
      headerName: 'SS Volume (Error)',
      width: COLUMN_WIDTH,
      type: 'number',
    },
    {
      field: 'ssVolumeByDemandVariability',
      headerName: 'SS Volume (Variability)',
      width: COLUMN_WIDTH,
      type: 'number',
    },
    {
      field: 'weeklySalesRateByForecastError',
      headerName: 'Weekly Sales Rate (Error)',
      width: COLUMN_WIDTH,
      type: 'number',
    },
    {
      field: 'weeklySalesRateByDemandVariability',
      headerName: 'Weekly Sales Rate (Variability)',
      width: COLUMN_WIDTH,
      type: 'number',
    },
    {
      field: 'dailySalesRate',
      headerName: 'Daily Sales Rate',
      width: COLUMN_WIDTH,
      type: 'number',
    },
    {
      field: 'forecastAccuracy',
      headerName: 'Forecast Accuracy',
      width: COLUMN_WIDTH,
      type: 'number',
    },
    {
      field: 'actualBAUVolumeInPallets',
      headerName: 'BAU Volume (Pallets)',
      width: COLUMN_WIDTH,
      type: 'number',
    },
    {
      field: 'cycleStockVolumeInPallets',
      headerName: 'Cycle Stock (Pallets)',
      width: COLUMN_WIDTH,
      type: 'number',
    },
    {
      field: 'unusedInventoryInPallets',
      headerName: 'Unused Inventory (Pallets)',
      width: COLUMN_WIDTH,
      type: 'number',
    },
    {
      field: 'ssVolumeByForecastErrorInPallets',
      headerName: 'SS Volume (Error, Pallets)',
      width: COLUMN_WIDTH,
      type: 'number',
    },
    {
      field: 'ssVolumeByDemandVariabilityInPallets',
      headerName: 'SS Volume (Variability, Pallets)',
      width: COLUMN_WIDTH,
      type: 'number',
    },
    { field: 'chosenMethod', headerName: 'Chosen Method', width: COLUMN_WIDTH },
    {
      field: 'safetyStockType',
      headerName: 'Safety Stock Type',
      width: COLUMN_WIDTH,
    },
  ]

  return (
    <Box
      sx={{
        display: 'flex',
        flex: 1,
        overflow: 'auto',
        flexDirection: 'column',
      }}
    >
      <BaseTable
        data={data}
        columns={columns}
        isLoading={isRefetching}
        updateTableData={() => {}}
        uploadData={() => {}}
        isUploading={false}
        isSaving={false}
      />
    </Box>
  )
}
